/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (Feature Categories)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Form validation utilities for Feature Categories.
────────────────────────────────────────────────────────────────*/

import { FormState, ValidationErrors } from '../types';

/**
 * Validate Feature Category form
 */
export function validateFeatureCategoryForm(
  formData: FormState,
  t: (key: string) => string
): ValidationErrors {
  const errors: ValidationErrors = {};
  const name = formData.name.trim();

  if (!name) {
    errors.name = t('featureCategories.validation.nameRequired');
  } else if (name.length < 3) {
    errors.name = t('featureCategories.validation.nameMinLength');
  }

  return errors;
}

